import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import AddEditAdminTip from '../components/AddEditAdminTip';
import { Dialog } from 'primereact/dialog';
import appUrl from "../../../../constants/appUrl";
const AdminTipOfDay = () => {

    const [dialog, setDialog] = useState();
    const [tipList, setTipList] = useState([]);

    const GetAllTips = async () => {
        try {
            const response = await fetch(`${appUrl.baseUrl}api/Tips/GetTips`)
            const data = await response.json();
            console.log('data', data)
            setTipList([data])
        }
        catch (error) {

        }
    }
    const actionTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-pencil" className="custom-btn-edit" />
                <Button icon="pi pi-trash" className="custom-btn-delete" />
            </div>
        );
    }

    const actionEye = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-eye" className="custom-btn-edit" />
            </div>
        );
    }


    const onHide = () => {
        setDialog(false)
    }
    useEffect(() => {
        GetAllTips()
    }, [])
    console.log('tipList', tipList)
    return (
        <>
            <Dialog visible={dialog} onHide={onHide}
                header={"New Product"}
                style={{ width: "70vw" }}>
                <AddEditAdminTip />
            </Dialog>
            <div className='card'>
                <div className='grid'>
                    <div className="md:col-8"></div>
                    <div className='md:col-2'>
                        <InputText className="w100" placeholder="Search" />
                    </div>

                    <div className="md:col-2" >
                        <div >
                            <Button className="p-button custom-bg w100" label="Add Slider Picture" onClick={() => { setDialog(true) }} />
                        </div>
                    </div>

                    <div className='md:col-12' >
                        <DataTable
                            value={tipList}
                            scrollable
                            scrollHeight="500px"
                            rows={5}
                            paginator
                        >
                            <Column
                                body={(rowData, index) => {
                                    return index.rowIndex + 1;
                                }}
                                header="Sr. No."
                            />
                            <Column header="CK Editor" body={actionEye} />
                            <Column header="Description" field='description' />
                            <Column header="Action" body={actionTemplate} />
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminTipOfDay